import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const WrapperRadio = styled.div`
  display: flex;
  position: relative;
`;

const StyledRadio = styled.input.attrs({
  type: 'radio'
})`
  cursor: pointer;
  height: 100%;
  left: 0;
  margin: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;
`;

const StyledLabel = styled.label`
  line-height: ${rem('20px')};
  font-size: ${props => props.theme.fontSize.small};
  padding-left: 0.5rem;
  flex: 1;
  ${props =>
    props.disabled &&
    css`
      color: ${props.theme.colors.grayDark};
    `};
`;

const StyledCheckable = styled.div`
  background: ${props => props.theme.colors.grayLighter};
  border: 1px solid ${props => props.theme.colors.light};
  border-radius: 100%;
  cursor: pointer;
  display: inline-block;
  height: ${rem('24px')};
  width: ${rem('24px')};
  ${props =>
    props.checked &&
    css`
      background: ${props => props.theme.colors.light};
      box-shadow: 0 0 0 ${rem('7px')} ${props => props.theme.colors.secondary},
        0 0 0 ${rem('9px')} ${props => props.theme.colors.colorTwo},
        0 0 0 10px ${props => props.theme.colors.light};
      margin: ${rem('6px')} ${rem('7px')} 0 ${rem('9px')};
      height: ${rem('8px')};
      width: ${rem('8px')};
    `};
  ${props =>
    props.disabled &&
    css`
      opacity: 0.4;
    `};
  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('19px')};
    width: ${rem('19px')};
    ${props =>
      props.checked &&
      css`
        box-shadow: 0 0 0 ${rem('4px')} ${props => props.theme.colors.secondary},
          0 0 0 ${rem('6px')} ${props => props.theme.colors.colorTwo},
          0 0 0 7px ${props => props.theme.colors.light};
        margin: ${rem('6px')} ${rem('7px')} 0 ${rem('6px')};
        height: ${rem('6px')};
        width: ${rem('6px')};
      `};
  `};
`;

export { WrapperRadio, StyledRadio, StyledLabel, StyledCheckable };
